module.exports = __webpack_public_path__ + "static/media/Frame 55 1.fa209a62.png";